
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetonashikbusonrent() {



    const cardData =
    {
        keyword: 'Pune to Nashik Bus on Rent',
        heading: 'Amruta Travels: Pune to Nashik Bus on Rent',
        headingDescription: 'Amruta Travels offers Pune to Nashik Bus on Rent, providing a convenient and comfortable travel option for groups heading to the city of temples and vineyards. Whether it is a religious tour to Trimbakeshwar, a wine-tasting getaway, or a corporate group trip, our buses ensure a smooth journey from Pune to Nashik. Enjoy safe travel with our well-maintained fleet of 17-seater, 32-seater, and 50-seater buses, driven by professional and experienced chauffeurs. With timely service, budget-friendly rates, and 24/7 availability, Amruta Travels makes your Pune to Nashik journey stress-free and enjoyable. Book your bus today and travel with comfort and confidence!',


        top: 'Top Places to Visit in Nashik with Amruta Travels',
"topPlaces": [
  {
    "title": "Trimbakeshwar Jyotirlinga",
    "description": "Located about 28 km from Nashik, Trimbakeshwar Temple is one of the 12 Jyotirlingas dedicated to Lord Shiva. Nestled at the source of the Godavari River, the temple features a unique lingam with three faces representing Brahma, Vishnu, and Shiva."
  },
  {
    "title": "Sula Vineyards",
    "description": "India's leading wine producer, Sula Vineyards offers guided tours, wine tastings, and a chance to relax amidst scenic vineyards. The estate also hosts the annual SulaFest, a popular music and wine festival."
  },
  {
    "title": "Pandav Leni Caves",
    "description": "Also known as Trirashmi Caves, these 24 rock-cut caves date back to between the 3rd century BCE and the 2nd century CE. They showcase intricate Buddhist sculptures and inscriptions, reflecting the Hinayana tradition."
  },
  {
    "title": "Saptashrungi Temple",
    "description": "Situated on a hill range with seven peaks, Saptashrungi is a revered shrine dedicated to Goddess Saptashrungi Nivasini. The temple offers panoramic views and is especially vibrant during Navratri festivals."
  },
  {
    "title": "Anjaneri Hills",
    "description": "Believed to be the birthplace of Lord Hanuman, Anjaneri Hills is a popular trekking destination. The trail offers scenic views and leads to ancient caves and a temple at the summit."
  },
  {
    "title": "Ramkund",
    "description": "A sacred bathing ghat on the Godavari River, Ramkund is where devotees perform rituals and immerse ashes of the departed. It's believed that Lord Rama bathed here during his exile."
  },
  {
    "title": "Kalaram Temple",
    "description": "An important Hindu shrine, the Kalaram Temple is dedicated to Lord Rama. Built in black stone, the temple is renowned for its architectural beauty and spiritual significance."
  },
  {
    "title": "Muktidham Temple",
    "description": "Constructed with white marble, Muktidham Temple complex houses replicas of 12 Jyotirlingas and images of various Hindu deities. It's a serene place for spiritual reflection."
  },
  {
    "title": "Dugarwadi Waterfall",
    "description": "Located about 30 km from Nashik, Dugarwadi is a picturesque waterfall surrounded by lush greenery. It's a popular spot for nature lovers, especially during the monsoon season."
  },
  {
    "title": "Statue of Ahimsa (Mangi Tungi)",
    "description": "Situated at Mangi Tungi hills, the Statue of Ahimsa is the world's tallest Jain idol at 108 feet. Dedicated to Lord Rishabhdeva, it's a significant pilgrimage site for Jains."
  }
],



    "services": [
    {
      "name": "Hire Pune to Nashik Mini Bus & Tempo Traveller on Rent",
      "description": "Amruta Travels offers mini bus and tempo traveller rentals from Pune to Nashik for family tours, corporate outings, and religious trips. Our fleet includes AC and Non-AC vehicles with professional drivers, ensuring a smooth and scenic ride to Nashik's spiritual and tourist destinations."
    },
    {
      "name": "Pune To Nashik Tempo Traveller Hire On Rent",
      "description": "Travel comfortably from Pune to Nashik in our spacious tempo travellers. Ideal for small to medium-sized groups, Amruta Travels provides 13 to 17-seater options with AC, push-back seats, and experienced drivers for a safe and relaxing journey."
    },
    {
      "name": "Hire Pune to Saputara Mini Bus & Tempo Traveller on Rent",
      "description": "Explore the beauty of Saputara with our mini buses and tempo travellers. Amruta Travels offers flexible rental options from Pune to Saputara, perfect for nature lovers, school trips, or weekend getaways. Enjoy scenic views with comfort and reliability."
    },
    {
      "name": "Pune to Sade Teen Shakti Peeth Bus On Rent",
      "description": "Book a comfortable bus from Pune to the revered Sade Teen Shakti Peeth pilgrimage destinations. Amruta Travels offers safe, punctual, and spiritually enriching trips with spacious seating and trained drivers, ideal for group religious tours."
    },
    {
      "name": "Pune to Saptashrungi Gad Bus on Rent",
      "description": "Visit the sacred hill temple of Saptashrungi with Amruta Travels’ bus rental services. Our AC and Non-AC buses provide a smooth ride for pilgrims, families, or group travelers seeking a peaceful darshan journey from Pune to Vani."
    },
    {
      "name": "Pune to Trimbakeshwar Bus Hire in Pune",
      "description": "Amruta Travels provides dependable bus rental services from Pune to Trimbakeshwar, one of the twelve Jyotirlingas. Ideal for spiritual groups and temple tours, our buses ensure a comfortable and punctual religious journey."
    },
    {
      "name": "Pune to Sula Vineyards Bus on Rent",
      "description": "Plan your luxury winery trip with Amruta Travels' bus rental to Sula Vineyards, Nashik. Our AC buses come with push-back seats and entertainment systems, making them ideal for leisure groups and wine tasting tours from Pune."
    },
    {
      "name": "Pune to Nashik Panchavati Bus on Rent",
      "description": "Book a group trip from Pune to Panchavati, Nashik with Amruta Travels. We offer buses in various capacities for religious, family, or student tours to the spiritually significant Panchavati region near the Godavari River."
    },
    {
      "name": "One Day Trip to Nashik From Pune",
      "description": "Enjoy a well-planned one-day trip from Pune to Nashik with Amruta Travels. Whether for pilgrimage, leisure, or education, our one-day rental packages include comfortable transport, on-time service, and flexible booking options."
    },
    {
      "name": "13,17 Seater Force Urbania on Rent in Nashik",
      "description": "Hire a premium Force Urbania 13 or 17-seater vehicle from Pune to Nashik. With luxurious interiors, AC comfort, and ample luggage space, these vehicles are ideal for high-end group travel to Nashik’s temples, vineyards, or tourist attractions."
    },
    {
      "name": "Pune To Igatpuri Bus On Rent",
      "description": "Planning a trip to Igatpuri? Amruta Travels offers bus rentals from Pune to Igatpuri, ideal for retreats, weekend breaks, and nature escapes. Enjoy a scenic ride through the Western Ghats in AC or Non-AC buses with experienced drivers."
    }
  ],
  "tableData": [
    ["Hire Pune to Nashik Mini Bus & Tempo Traveller on Rent", "Pune To Nashik Tempo Traveller Hire On Rent"],
    ["Hire Pune to Saputara Mini Bus & Tempo Traveller on Rent", "Pune to Sade Teen Shakti Peeth Bus On rent"],
    ["Pune to Saptashrungi Gad Bus on Rent", "Pune to Trimbakeshwar Bus hire in Pune"],
    ["Pune to Sula Vineyards Bus on Rent", "Pune to Nashik Panchavati bus on Rent"],
    ["One Day Trip to Nashik From Pune", "13,17 Seater Force Urbania on Rent in Nashik"],
    ["Pune To Igatpuri Bus On Rent", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Stress-Free Travel to Nashik",
    "WhyChoosedescription": "Amruta Travels offers Pune to Nashik Bus on Rent, ensuring a comfortable and relaxing journey to one of Maharashtra’s most revered cities. Our buses are equipped with spacious seating, air conditioning, and modern amenities to ensure your travel is both comfortable and enjoyable. Whether you're traveling for religious purposes, leisure, or business, we provide reliable transportation to Nashik, allowing you to travel with ease and convenience."
  },
  {
    "WhyChooseheading": "Perfect for Pilgrimages, Sightseeing, and Group Outings",
    "WhyChoosedescription": "Whether you are visiting Nashik for the famous Trimbakeshwar Temple, exploring the city’s vineyards, or attending a cultural or business event, our buses offer the ideal solution for group travel. We accommodate large groups for pilgrimages, sightseeing, family outings, and corporate tours, providing ample space and comfort throughout the journey. With spacious seating and enough room for luggage, we ensure your entire group can travel together seamlessly."
  },
  {
    "WhyChooseheading": "Experienced and Reliable Drivers for a Safe Journey",
    "WhyChoosedescription": "Safety is always our top priority. Our experienced drivers are not only familiar with the Pune to Nashik route but are also trained to ensure safe, timely, and comfortable travel. They prioritize passenger safety and adhere to all traffic regulations, giving you peace of mind during your journey. Friendly and professional, our drivers will make sure your trip to Nashik is as smooth and stress-free as possible."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "At Amruta Travels, we offer affordable pricing for Pune to Nashik Bus on Rent. Our transparent pricing structure ensures there are no hidden charges or surprises, allowing you to plan your trip with confidence. Whether it’s a one-day excursion or an extended tour, we offer competitive rates to suit any budget while maintaining the highest level of comfort and safety."
  },
  {
    "WhyChooseheading": "Well-Maintained, Clean, and Hygienic Buses",
    "WhyChoosedescription": "Our buses are meticulously maintained, regularly cleaned, and sanitized to ensure the highest standards of hygiene and comfort. From the seating to the interiors, we take every step to ensure that your ride is pleasant and safe. Whether you’re embarking on a short trip or a long-distance journey to Nashik, you can count on our buses to provide a comfortable and clean environment."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations in Pune and Nashik",
    "WhyChoosedescription": "We offer flexible pickup and drop-off options throughout Pune and Nashik, ensuring convenience and ease for your group. Whether you’re starting from a hotel, office, or any other specific location, we can accommodate your preferred pick-up points and ensure timely departures. Upon arrival in Nashik, we will also make sure your drop-off location is convenient for you and your group."
  },
  {
    "WhyChooseheading": "Customizable Itinerary to Suit Your Group’s Needs",
    "WhyChoosedescription": "Every group trip is unique, and we understand that. We offer fully customizable itineraries for your trip to Nashik, whether you wish to visit specific temples, vineyards, or other local attractions. Our team will work with you to create an itinerary that fits your group’s specific needs, including special stops, extended stays, or additional locations along the way. Flexibility is key to ensuring your trip is tailored to your preferences."
  },
  {
    "WhyChooseheading": "Easy Booking Process with Dedicated Customer Support",
    "WhyChoosedescription": "Booking your Pune to Nashik bus rental with Amruta Travels is simple and hassle-free. You can book online, contact our customer service, or visit our office for personalized assistance. Our team is dedicated to helping you with the booking process, answering any questions, and ensuring your travel experience is well-organized from start to finish. Whether you're a first-time customer or a returning traveler, we provide full support to make your trip stress-free."
  }
]



























    }

const faqData = [
  {
    question: 'How can I rent a bus for a trip from Pune to Nashik?',
    answer: 'Renting a bus for your Pune to Nashik trip with Amruta Travels is easy. You can book online, call our support team, or visit our office. We’ll help you choose the best bus based on your group size and trip preferences.',
  },
  {
    question: 'What types of buses are available for the Pune to Nashik trip?',
    answer: 'We offer a range of buses for the Pune to Nashik journey, including 32, 35, 45, and 50-seater options. Whether you need a standard or luxury bus, we have a vehicle to fit your travel requirements.',
  },
  {
    question: 'How long does it take to travel from Pune to Nashik?',
    answer: 'The travel time from Pune to Nashik is approximately 4 to 5 hours, depending on traffic conditions. Our experienced drivers ensure a smooth and safe journey, allowing you to relax and enjoy the ride.',
  },
  {
    question: 'Are the buses comfortable for the Pune to Nashik journey?',
    answer: 'Yes, all our buses are well-maintained and equipped with comfortable seating, air conditioning, and spacious interiors. We ensure a comfortable ride for everyone throughout the journey to Nashik.',
  },
  {
    question: 'Can I book a bus for a one-day trip to Nashik?',
    answer: 'Yes, we offer flexible booking options for one-day trips to Nashik. We can customize the itinerary based on the places you wish to visit, including popular spots like Trimbakeshwar Temple and Saptashrungi.',
  },
  {
    question: 'Do you provide both standard and luxury buses for the Pune to Nashik trip?',
    answer: 'Yes, we offer both standard and luxury buses. Our luxury buses come with additional amenities such as premium seating, air conditioning, and entertainment options, ensuring a high-end travel experience for your group.',
  },
  {
    question: 'How much does it cost to rent a bus for Pune to Nashik?',
    answer: 'The cost depends on the bus size, trip duration, and any additional services you may need. Please contact us with your trip details, and we’ll provide a customized and transparent quote.',
  },
  {
    question: 'Can I request specific pickup and drop-off locations for the trip?',
    answer: 'Yes, we offer flexible pickup and drop-off locations. Just let us know your preferred locations in Pune and Nashik, and we’ll plan the best route for your convenience.',
  },
  {
    question: 'Why choose Amruta Travels for Pune to Nashik bus rental?',
    answer: 'Amruta Travels is known for offering reliable, comfortable, and timely bus services for trips between Pune and Nashik. Our experienced drivers, well-maintained buses, and customer-first approach ensure a hassle-free and pleasant travel experience.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ashok Patil',
    role: 'Corporate Travel Manager, Pune',
    text: 'We rented a 45-seater bus from Amruta Travels for a corporate trip to Nashik. The bus was clean, comfortable, and the driver was courteous. The entire experience was smooth, and the service exceeded our expectations!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Kulkarni',
    role: 'Traveler, Pune',
    text: 'I booked a 35-seater bus for a family trip to Nashik. The bus was very comfortable, and the driver made sure we had a safe and enjoyable journey. We visited Trimbakeshwar and had a fantastic time. Highly recommend Amruta Travels for a trip to Nashik!',
    rating: 5,
  },
];














































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nashik Bus on Rent",
  "image": "https://bushireinpune.com/assets/images/pune-to-nashik-bus-on-rent.jpg",
  "description": "Hire Pune to Nashik Mini Bus & Tempo Traveller on Rent. Includes Pune to Saputara, Saptashrungi Gad, Trimbakeshwar, Sula Vineyards, Panchavati, and Igatpuri. Choose 13 or 17 Seater Force Urbania, perfect for one-day trips and group travel.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "3890"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4499",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-nashik-bus-on-rent"
  }
};








    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Pune to Nashik Bus on Rent | Mini Bus & Tempo Traveller Hire | Amruta Travels</title>
  <meta 
    name="description" 
    content="Hire buses from Pune to Nashik, Trimbakeshwar, Sula Vineyards, Saputara, Saptashrungi Gad, and more. Choose 13 or 17 Seater Urbania for group travel. Book your journey with Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/31.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetonashikbusonrent;